import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { setupPwa } from './pwa.js';
import { purgeExpiredSessions } from './core/transfer/resume-store.js';
import './styles.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Élément #root introuvable : le document HTML a été modifié ?');
}

// Enregistrement du service worker et capture de l'invitation à installer.
// Sans effet en développement, où un service worker casserait le rechargement à chaud.
setupPwa();

// Purge des sessions de reprise périmées (> 7 jours). Au démarrage et non à intervalle :
// la seule chose qui compte est qu'un état oublié ne survive pas indéfiniment (et avec
// lui la poignée de fichier persistée). `void` : une purge qui échoue (mode privé, quota)
// ne doit pas bloquer l'application — la reprise est un confort, pas une fonction.
void purgeExpiredSessions();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
